export function isHTMLElement(el: Element | null): el is HTMLElement {
  return el instanceof HTMLElement;
}

export function formatCurrencyFromCents(
  price: number,
  currency: string,
  locale = "en-US",
) {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(price);
}

export async function withRetry<T>(
  fn: () => Promise<T>,
  retries = 3,
  delay = 300,
): Promise<T> {
  try {
    return await fn();
  } catch (e) {
    if (retries <= 0) throw e;
    await new Promise((r) => setTimeout(r, delay));
    return withRetry(fn, retries - 1, delay * 2);
  }
}

export const validateViewPosition = (
  mainElement: HTMLElement,
  item: HTMLElement,
  wrapperElement: HTMLElement,
) => {
  if (!mainElement) return;

  const itemRect = item.getBoundingClientRect();
  const wrapperRect = wrapperElement.getBoundingClientRect();
  const windowWidth = window.innerWidth;

  const leftPosition = itemRect.left - wrapperRect.left;

  mainElement.style.left = `${leftPosition}px`;
  mainElement.style.right = "auto";

  requestAnimationFrame(() => {
    if (!mainElement) return;
    const popupRect = mainElement.getBoundingClientRect();

    if (popupRect.right > windowWidth) {
      mainElement.style.left = "auto";
      mainElement.style.right = `${wrapperRect.right - itemRect.right}px`;
    }
  });
};

export { fetchSection } from "./fetchSection";
